import React from "react"
import Icon from "../../Icon/Icon"
import TextField from "../TextField/TextField"
import * as Yup from "yup"

const jwksPathSchema = Yup.string().required("JWKS Path is required").url("JWKS Path must be a valid URL")
const jwtIssuerSchema = Yup.string().required("JWT Issuer is required")
const audienceSchema = Yup.string().required("JWT Audience is required")

export default function CustomWithJWKSFields() {
	return (
		<fieldset className="fields">
			<TextField
				name="jwksPath"
				label="JWKS Path"
				placeholder="https://your-domain.com/.well-known/jwks.json"
				validationSchema={jwksPathSchema}
				helpElements={
					<>
						<Icon
							icon="information-circle--interface-essential"
							size={12}
							data-tip="React-tooltip"
							data-for="jwks-path-tooltip"
						/>
						<a className="jwks-button link" href="https://jwt.io/introduction" target="_blank" rel="noreferrer">
							How to find my JWKS
						</a>
					</>
				}
			/>
			<TextField name="jwtIssuer" label="JWT Issuer" placeholder="Your JWT issuer" validationSchema={jwtIssuerSchema} />
			<TextField
				name="audience"
				label="JWT Audience"
				placeholder="Your JWT audience"
				validationSchema={audienceSchema}
			/>
		</fieldset>
	)
}
